"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var root_reducer_1 = require("./root.reducer");

exports.authReducer = root_reducer_1.authReducer;